import Vue from "vue";
import App from "./App.vue";
import "amfe-flexible/index.js";
import "./common/filters";
import * as $dom from "./common/dom";
import "./components/index";
import "./mixin";
import router from "./router";
import store from "./store";
import "normalize.css/normalize.css";
import axios from "axios";
import "./apis";
import i18n from "./i18n/index";

import "./lbScss/lb.scss";

import Vant from "vant";
import "vant/lib/index.css";
import "vant/lib/icon/local.css"; //引用字体css
import "./styles/index.scss";

Vue.use(Vant);
sessionStorage.setItem("shopId", 217);

import dayjs from "dayjs";
Vue.prototype.dayjs = dayjs;

// import ElementUI from "element-ui";
// import "element-ui/lib/theme-chalk/index.css";
// Vue.use(ElementUI);

import { Locale } from 'vant';
import enUS from 'vant/lib/locale/lang/en-US';
import zhCN from 'vant/lib/locale/lang/zh-CN';
const language = localStorage.getItem('language');
if (language == 'CN') {
  Locale.use('zh-CN', zhCN);
} else {
  Locale.use('en-US', enUS);
}


import "./icons/index";

import VConsole from "vconsole";

// eslint-disable-next-line no-console

if (process.env.NODE_ENV == "production") {
  // axios.defaults.baseURL = 'https://binguoai.com';
  // new VConsole();
  axios.defaults.baseURL = "/";
} else {
  // new VConsole();
  axios.defaults.baseURL = "/dev";
}

const echarts = require("echarts");

Vue.prototype.$echarts = echarts;

Vue.prototype.$http = axios;
Vue.config.productionTip = false;
Vue.prototype.$dom = $dom;

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
